/**
 * Roles Reducers
 */
 import {
    ALL_PROGRAMINCLUSION,
    ADD_PROGRAMINCLUSION,
    PROGRAMINCLUSION_ACTION,
    EDIT_PROGRAMINCLUSION,
    STATUS_PROGRAMINCLUSION,
    DELETE_PROGRAMINCLUSION
 } from 'Actions/types';

/**
 * initial auth user
 */
const INIT_STATE = {
    programinclusionlists:[],
    loading: false
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        
        case PROGRAMINCLUSION_ACTION:
            return { ...state, loading: true };

        case ALL_PROGRAMINCLUSION:
            return { ...state, loading: false, programinclusionlists: action.payload };  
            
        case ADD_PROGRAMINCLUSION:
            return { ...state, loading: false }; 
        
        case EDIT_PROGRAMINCLUSION:
            return { ...state, loading: false };  
        
        case STATUS_PROGRAMINCLUSION:
            return { ...state, loading: false };    
        
        case DELETE_PROGRAMINCLUSION:
            return { ...state, loading: false };      

        default: return { ...state };
    }
}